module.exports = __webpack_public_path__ + "static/media/user1.0d0c85aa.png";